import {Injectable} from '@angular/core';
import {ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree} from '@angular/router';
import {Observable} from 'rxjs';
import {AuthHelperService} from '../services/auth-helper.service';

@Injectable({
  providedIn: 'root',
})
export class HasRoleGuard implements CanActivate {
  constructor(private authHelper: AuthHelperService, private router: Router) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    const hasRole = this.authHelper.hasRole(route.data.roles);
    if (!hasRole && this.authHelper.isAuthenticated()) {
      this.router.navigate(['/error/403']);
    }
    return hasRole;
  }
}
